<template>
  <div class="upload-file">
    <template v-if="currentImage">
      <div
        class="text-xs-center preview-img"
        style="
          overflow: hidden;
          min-height: 150px;
          background-position: center;
          background-repeat: no-repeat;
        "
        :style="{
          'min-height': height + 'px',
          'background-image': 'url(\'' + showImage + '\')',
          'background-size': backgroundSize,
        }"
      >
        <template v-if="loading">
          <div
            style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
          >
            <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
          </div>
        </template>
        <div v-else class="overlay">
          <v-layout
            justify-center
            fill-height
            align-center
            row
            class="mb-0"
            style="min-height: 100%"
            :style="{ 'min-height': height + 'px' }"
          >
            <div @click="onClickUploadButton(index)">
              <slot>
                <v-btn
                  small
                  depressed
                  color="color-gradientBlue"
                  style="font-size: 16px; padding: 6px 21px; color: #ffffff; height: 35px"
                >
                  <span class="fa fa-camera mr-1"></span>
                  {{ $t('เลือกไฟล์ภาพ') }}
                </v-btn>
                <div class="caption text-xs-center" style="color: white">
                  {{ $t('upload file size: {size}MB', { size: 5 }) }}
                </div>
              </slot>
            </div>
          </v-layout>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="text-xs-center">
        <div
          style="
            min-height: 150px;
            background: #eee;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
          "
          :style="{ 'min-height': height + 'px' }"
        >
          <template v-if="loading">
            <div
              style="position: absolute; top: 50%; left: 50%; margin-top: -10px; margin-left: -21px"
            >
              <sync-loader :color="$vuetify.theme.primary" :size="'10px'"></sync-loader>
            </div>
          </template>
          <template v-else>
            <v-layout
              justify-center
              fill-height
              align-center
              row
              class="mb-0"
              style="min-height: 100%"
              :style="{ 'min-height': height + 'px' }"
            >
              <div @click="onClickUploadButton(index)">
                <slot>
                  <v-btn
                    small
                    depressed
                    color="color-gradientBlue"
                    style="font-size: 16px; padding: 6px 21px; color: #ffffff; height: 35px"
                  >
                    <div>
                      <span class="fa fa-camera mr-1" />
                      {{ $t('เลือกไฟล์ภาพ') }}
                    </div>
                  </v-btn>
                  <div class="caption text-center" style="color: #818181; font-weight: 600">
                    {{ $t('upload file size: {size}MB', { size: 5 }) }}
                  </div>
                </slot>
              </div>
            </v-layout>
          </template>
        </div>
      </div>
    </template>
    <input
      type="file"
      class="form-control-file pt-2"
      name="photoUpload"
      :id="`photoUploadInputtest-${index}`"
      data-vv-as="File"
      v-validate="'image|size:5120|mimes:image/jpeg,image/png,image/jpg,image/gif,application/pdf'"
      accept=".jpg, .png, .jpeg, .gif, .pdf"
      @change="onFileChange($event)"
      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
    />
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config' // config.serverUrl
import api from '@/api'

import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import moment from 'moment'
const imgLink = require('../../../static/img/pdf-image-placeholder.png')

export default {
  props: {
    value: null,

    width: {
      default: 120,
    },
    height: {
      default: 350,
      type: Number,
    },
    backgroundSize: {
      default: 'cover',
      type: String,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SyncLoader,
  },
  data: function () {
    return {
      showUpload: false,
      currentImage: this.value,
      isAlert: false,
      loading: false,
      uploadtimestamp: moment().format('x'),
    }
  },
  computed: {
    showImage() {
      return /(\.pdf$)/.test(this.currentImage) ? imgLink : this.currentImage
    },
  },
  methods: {
    onClickUploadButton: function (index) {
      document.getElementById(`photoUploadInputtest-${index}`).click()
    },
    onClickUploadFile() {
      var vm = this
      vm.uploadtimestamp = moment().format('x')
      vm.$nextTick(() => {
        vm.$refs.inputUpload.click()
      })
    },
    onClickUploadBtn() {
      document.getElementById('photoUploadInput').click()
    },
    fileResize: function (file, callback) {
      let vm = this
      var reader = new FileReader()
      reader.onloadend = function () {
        var tempImg = new Image()
        tempImg.src = reader.result
        tempImg.onload = function () {
          var MAX_WIDTH = 1000
          var MAX_HEIGHT = 1000
          var tempW = tempImg.width
          var tempH = tempImg.height
          if (tempW > tempH) {
            if (tempW > MAX_WIDTH) {
              tempH *= MAX_WIDTH / tempW
              tempW = MAX_WIDTH
            }
          } else {
            if (tempH > MAX_HEIGHT) {
              tempW *= MAX_HEIGHT / tempH
              tempH = MAX_HEIGHT
            }
          }

          var canvas = document.createElement('canvas')
          canvas.width = tempW
          canvas.height = tempH
          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tempW, tempH)
          var dataURL = canvas.toDataURL('image/jpeg')
          var data = 'image=' + dataURL
          var obj = vm.dataURItoBlob(data)
          obj.name = file.name
          callback(obj)
        }
      }
      reader.readAsDataURL(file)
    },
    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    onFileChange: async function (event) {
      this.isAlert = false
      let vm = this
      var isValid = true

      if (!isValid) {
        vm.uploadtimestamp = moment().format('x')
        return false
      }
      let files = event.target.files || event.dataTransfer.files
      var isAllImage = true
      for (var i = 0; i < files.length; i++) {
        if (!files[i].type.includes('image')) {
          isAllImage = false
          break
        }
      }

      if (isAllImage) {
        if (!files.length) {
          vm.uploadtimestamp = moment().format('x')
          return
        }
        // vm.fileResize(files[0], function(obj) {});
        vm.createImage(files[0])
        event.target.value = ''
      }
    },
    createImage(file) {
      // let reader = new FileReader();
      let vm = this
      vm.upload(file)
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file,
      }
      let vm = this
      vm.loading = true

      // let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type
      api.getSignedRequest(data, function (error, url) {
        if (error) {
          console.error(error)
        }
        let url_temp = encodeURI(url)
        vm.currentImage = url_temp
        vm.loading = false
        vm.uploadtimestamp = moment().format('x')
        vm.$emit('input', vm.currentImage)
      })
    },
  },
  watch: {
    value: function (newVal) {
      this.currentImage = newVal
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/elements/uploadfiletest.vue